import { Encoder, Utils } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
export class LodestoneMove extends MoveCoord {
    direction;
    orientation;
    captures;
    static encoder = new class extends Encoder {
        encode(move) {
            return {
                coord: Coord.encoder.encode(move.coord),
                direction: move.direction,
                orientation: move.orientation,
                captures: move.captures,
            };
        }
        decode(encoded) {
            const casted = encoded;
            Utils.assert(casted.coord != null, 'Invalid encoded LodestoneMove');
            Utils.assert(casted.direction != null, 'Invalid encoded LodestoneMove');
            Utils.assert(casted.orientation != null, 'Invalid encoded LodestoneMove');
            Utils.assert(casted.captures != null, 'Invalid encoded LodestoneMove');
            return new LodestoneMove(Coord.encoder.decode(casted.coord), casted.direction, casted.orientation, casted.captures);
        }
    };
    constructor(coord, direction, orientation, captures = { top: 0, bottom: 0, left: 0, right: 0 }) {
        super(coord.x, coord.y);
        this.direction = direction;
        this.orientation = orientation;
        this.captures = captures;
    }
    toString() {
        return `LodestoneMove(${this.coord.toString()}, ${this.direction}, ${this.orientation}, { top: ${this.captures.top}, bottom: ${this.captures.bottom}, left: ${this.captures.left}, right: ${this.captures.right} })`;
    }
    equals(other) {
        if (this === other)
            return true;
        if (this.coord.equals(other.coord) === false)
            return false;
        if (this.orientation !== other.orientation)
            return false;
        if (this.direction !== other.direction)
            return false;
        if (this.captures.top !== other.captures.top)
            return false;
        if (this.captures.bottom !== other.captures.bottom)
            return false;
        if (this.captures.left !== other.captures.left)
            return false;
        if (this.captures.right !== other.captures.right)
            return false;
        return true;
    }
}
